export var DEFAULT_TOAST_DURATION_MS = 7000;
export var DEFAULT_MAX_STACKED_TOASTS = 3;